import lambdaApi from 'api/LambdaApi';
import { useQuery } from 'react-query';

import { getExtIntQueryKey, skillsDBPrefix } from '.';

export const useStatusHook = (isExternal?: boolean) => {
    return () => {
        const getUri = isExternal ? `${skillsDBPrefix}/ext/status` : `${skillsDBPrefix}/status`;

        const {
            data,
            isLoading: isNeo4jLoading,
            isFetched: isNeo4jFetched,
        } = useQuery(
            ['skills_db_status', getExtIntQueryKey(isExternal)],
            () => lambdaApi.get(getUri, {}).then(res => res.data),
            {
                retry: false,
            },
        );

        const isNeo4jAvailable = data?.status === 'ok';

        return {
            isNeo4jAvailable,
            isNeo4jLoading,
            isNeo4jFetched,
        };
    };
};
